import { icon, Icon } from '../lib/fa-icons.js';
import $ from "jquery";
import isEmpty from "lodash/isEmpty";
import Widget from "./base.js";
import getProfile from "tpm-lib/profile";
import { env } from "tpm-utils";

export class Plugs extends Widget {
	constructor(props) {
		super(props);

		this.state = {
			likes: null,
			userHasLiked: false,
		};
	}

	componentDidMount() {
		const profileData = this.getProfileData();
		const self = this;

		let isPrime = false;
		let userId = null;

		function setUp(isPrime = false, userId = null) {
			if (!userId) {
				// console.error("userId is required to use Plugs");
				return;
			}

			self
				.getPlugData(userId)
				.then((data) => {
					return data.json();
				})
				.then((data) => {
					let likes = 0;
					let userHasLiked = false;
					if (!isEmpty(data)) {
						likes = data.total;
						userHasLiked = data.plugged;
					}

					self.setState({
						likes: likes,
						userHasLiked: userHasLiked,
						userId: userId,
						isPrime: isPrime,
					});
				});
		}

		/* first get profile data, then get plugs data */
		if (typeof profileData.then === "function") {
			// promise
			profileData
				.then((resp) => {
					return [resp.isPrime() || resp.isStaff(), resp.id];
				})
				.then((data) => {
					setUp(data[0], data[1]);
				});
		} else {
			//not a promise
			isPrime = profileData.isPrime() || profileData.isStaff();
			userId = profileData.id;
			setUp(isPrime, userId);
		}
	}

	getProfileData() {
		if (window.tpm_profile) return window.tpm_profile;
		const p = getProfile();
		return p;
	}

	getPlugData(userId) {
		return fetch(
			`https://accounts.${document.location.hostname}/doesspress/plugs?plug=${this.postId}&userid=${userId}`,
			{
				method: "GET",
				credentials: "omit",
			}
		)
			.then((r) => {
				return r; /* it works, pipe that data along */
			})
			.catch((r) => {
				console.log("getPlugData error", r);
			});
	}

	updatePlugData(type) {
		return fetch(
			`https://accounts.${document.location.hostname}/doesspress/plugs?plug=${this.postId}&userid=${this.userId}`,
			{
				method: type,
				credentials: "omit",
			}
		)
			.then((response) => {
				return response; /* it works, pipe that data along */
			})
			.catch((response) => {
				console.log(`plugs ${type} request error`, response);
			});
	}

	get postId() {
		return this.props.postid;
	}

	get userId() {
		return this.state.userId;
	}

	get count() {
		return this.state.likes;
	}

	handleClick() {
		this.setState({
			likes: this.state.userHasLiked ? this.count - 1 : this.count + 1,
			userHasLiked: !this.state.userHasLiked,
		});

		this.updatePlugData(this.state.userHasLiked ? "DELETE" : "PUT");
	}

	renderContent() {
		return (
			<div class="Plugs__Inner" onClick={this.handleClick.bind(this)}>
				<button
					class={`Plugs__Button ${
						this.state.userHasLiked ? "--liked" : "--not-liked"
					}`}
				>
					<div class={`Plugs__Icon ${this.state.userHasLiked ? "" : "--show"}`}>
						<Icon name="thumbs-up" style="light" />
					</div>
					<div class={`Plugs__Icon ${this.state.userHasLiked ? "--show" : ""}`}>
						<Icon name="thumbs-up" style="solid" />
					</div>
				</button>
				<div class="Plugs__Counter">
					<div class="count">{this.state.likes || "0"}</div>
				</div>
			</div>
		);
	}
}
